var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-upload', {
    ref: "upload",
    class: _vm.getUploadMode,
    attrs: {
      "headers": {
        token: _vm.$store.state.app.token
      },
      "action": _vm.action,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.uploadSuccess,
      "on-remove": _vm.uploadRemove,
      "on-progress": _vm.uploadProgress,
      "on-error": _vm.uploadError,
      "data": _vm.data,
      "show-file-list": this.showFileList,
      "accept": _vm.accept,
      "file-list": _vm.fileList
    }
  }, [(_vm.$slots.default) ? [_vm._t("default")] : [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("文件上传")])], _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._t("tip", [_vm._v("支持doc、docx、xls、xlsx、ppt、pptx、pdf、jpg、jpeg、gif、psd、png、swf、avi、htm、html等格式，建议大小不超过20MB\n            ")])], 2)], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-392bb8e1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileUpload.vue
// module id = null
// module chunks = 